Vue.component(
    "salepage-body-create-component",
    require("./Create.vue").default
);

Vue.component("salepage-body-edit-component", require("./Edit.vue").default);
Vue.component(
    "linktree-create-component",
    require("./LinktreeCreate.vue").default
);
Vue.component("linktree-component", require("./Linktree.vue").default);
Vue.component(
    "linktree-content-component",
    require("./LinktreeContent.vue").default
);
Vue.component("slide-component", require("./Slide.vue").default);
